// src/components/learning/arabicLettersData.js
// Données complètes des 28 lettres de l'alphabet arabe

export const arabicLetters = [
  // 1. ALIF
  {
    id: 1,
    letter: "أ",
    name: "Alif",
    nameAr: "أَلِف",
    forms: {
      isolated: "ا",
      initial: "ا",
      medial: "ـا",
      final: "ـا"
    },
    transliteration: "a / â",
    pronunciation: "Comme le 'a' français",
    audio: "/audio/letters/alif.mp3",
    examples: [
      {
        word: "أَسَد",
        transliteration: "asad",
        meaning: "lion",
        audio: "/audio/words/asad.mp3"
      },
      {
        word: "أَب",
        transliteration: "ab",
        meaning: "père",
        audio: "/audio/words/ab.mp3"
      }
    ],
    notes: "Lettre qui ne se lie jamais à la lettre suivante. C'est une lettre 'solaire'.",
    color: "#e74c3c"
  },

  // 2. BA
  {
    id: 2,
    letter: "ب",
    name: "Ba",
    nameAr: "بَاء",
    forms: {
      isolated: "ب",
      initial: "بـ",
      medial: "ـبـ",
      final: "ـب"
    },
    transliteration: "b",
    pronunciation: "Comme le 'b' français",
    audio: "/audio/letters/ba.mp3",
    examples: [
      {
        word: "بَيْت",
        transliteration: "bayt",
        meaning: "maison",
        audio: "/audio/words/bayt.mp3"
      },
      {
        word: "بَاب",
        transliteration: "bab",
        meaning: "porte",
        audio: "/audio/words/bab.mp3"
      }
    ],
    notes: "Un point en dessous. Se lie des deux côtés.",
    color: "#3498db"
  },

  // 3. TA
  {
    id: 3,
    letter: "ت",
    name: "Ta",
    nameAr: "تَاء",
    forms: {
      isolated: "ت",
      initial: "تـ",
      medial: "ـتـ",
      final: "ـت"
    },
    transliteration: "t",
    pronunciation: "Comme le 't' français",
    audio: "/audio/letters/ta.mp3",
    examples: [
      {
        word: "تُفَّاح",
        transliteration: "tuffah",
        meaning: "pomme",
        audio: "/audio/words/tuffah.mp3"
      },
      {
        word: "تَمْر",
        transliteration: "tamr",
        meaning: "dattes",
        audio: "/audio/words/tamr.mp3"
      }
    ],
    notes: "Deux points au-dessus. Même forme de base que ب et ث.",
    color: "#9b59b6"
  },

  // 4. THA
  {
    id: 4,
    letter: "ث",
    name: "Tha",
    nameAr: "ثَاء",
    forms: {
      isolated: "ث",
      initial: "ثـ",
      medial: "ـثـ",
      final: "ـث"
    },
    transliteration: "th",
    pronunciation: "Comme le 'th' anglais dans 'think'",
    audio: "/audio/letters/tha.mp3",
    examples: [
      {
        word: "ثَعْلَب",
        transliteration: "tha'lab",
        meaning: "renard",
        audio: "/audio/words/thalab.mp3"
      },
      {
        word: "ثَلْج",
        transliteration: "thalj",
        meaning: "neige",
        audio: "/audio/words/thalj.mp3"
      }
    ],
    notes: "Trois points au-dessus. Son 'th' doux (interdental).",
    color: "#1abc9c"
  },

  // 5. JIM
  {
    id: 5,
    letter: "ج",
    name: "Jim",
    nameAr: "جِيم",
    forms: {
      isolated: "ج",
      initial: "جـ",
      medial: "ـجـ",
      final: "ـج"
    },
    transliteration: "j / g",
    pronunciation: "Comme le 'j' français ou 'g' égyptien",
    audio: "/audio/letters/jim.mp3",
    examples: [
      {
        word: "جَمَل",
        transliteration: "jamal",
        meaning: "chameau",
        audio: "/audio/words/jamal.mp3"
      },
      {
        word: "جَبَل",
        transliteration: "jabal",
        meaning: "montagne",
        audio: "/audio/words/jabal.mp3"
      }
    ],
    notes: "Un point au milieu. Prononciation varie selon les dialectes.",
    color: "#e67e22"
  },

  // 6. HA
  {
    id: 6,
    letter: "ح",
    name: "Ha",
    nameAr: "حَاء",
    forms: {
      isolated: "ح",
      initial: "حـ",
      medial: "ـحـ",
      final: "ـح"
    },
    transliteration: "ḥ",
    pronunciation: "H aspiré profond, du fond de la gorge",
    audio: "/audio/letters/ha.mp3",
    examples: [
      {
        word: "حَلِيب",
        transliteration: "halib",
        meaning: "lait",
        audio: "/audio/words/halib.mp3"
      },
      {
        word: "حُب",
        transliteration: "hubb",
        meaning: "amour",
        audio: "/audio/words/hubb.mp3"
      }
    ],
    notes: "Sans point. Son guttural typiquement arabe.",
    color: "#2ecc71"
  },

  // 7. KHA
  {
    id: 7,
    letter: "خ",
    name: "Kha",
    nameAr: "خَاء",
    forms: {
      isolated: "خ",
      initial: "خـ",
      medial: "ـخـ",
      final: "ـخ"
    },
    transliteration: "kh",
    pronunciation: "Comme le 'ch' allemand dans 'Bach' ou 'j' espagnol",
    audio: "/audio/letters/kha.mp3",
    examples: [
      {
        word: "خُبْز",
        transliteration: "khubz",
        meaning: "pain",
        audio: "/audio/words/khubz.mp3"
      },
      {
        word: "خَيْر",
        transliteration: "khayr",
        meaning: "bien",
        audio: "/audio/words/khayr.mp3"
      }
    ],
    notes: "Un point au-dessus. Son fricatif vélaire.",
    color: "#f39c12"
  },

  // 8. DAL
  {
    id: 8,
    letter: "د",
    name: "Dal",
    nameAr: "دَال",
    forms: {
      isolated: "د",
      initial: "د",
      medial: "ـد",
      final: "ـد"
    },
    transliteration: "d",
    pronunciation: "Comme le 'd' français",
    audio: "/audio/letters/dal.mp3",
    examples: [
      {
        word: "دَجَاج",
        transliteration: "dajaj",
        meaning: "poulet",
        audio: "/audio/words/dajaj.mp3"
      },
      {
        word: "دُب",
        transliteration: "dubb",
        meaning: "ours",
        audio: "/audio/words/dubb.mp3"
      }
    ],
    notes: "Ne se lie pas à la lettre suivante (comme Alif).",
    color: "#8e44ad"
  },

  // 9. DHAL
  {
    id: 9,
    letter: "ذ",
    name: "Dhal",
    nameAr: "ذَال",
    forms: {
      isolated: "ذ",
      initial: "ذ",
      medial: "ـذ",
      final: "ـذ"
    },
    transliteration: "dh",
    pronunciation: "Comme le 'th' anglais dans 'this'",
    audio: "/audio/letters/dhal.mp3",
    examples: [
      {
        word: "ذَهَب",
        transliteration: "dhahab",
        meaning: "or",
        audio: "/audio/words/dhahab.mp3"
      },
      {
        word: "ذِئْب",
        transliteration: "dhi'b",
        meaning: "loup",
        audio: "/audio/words/dhib.mp3"
      }
    ],
    notes: "Un point au-dessus. Ne se lie pas à la lettre suivante.",
    color: "#16a085"
  },

  // 10. RA
  {
    id: 10,
    letter: "ر",
    name: "Ra",
    nameAr: "رَاء",
    forms: {
      isolated: "ر",
      initial: "ر",
      medial: "ـر",
      final: "ـر"
    },
    transliteration: "r",
    pronunciation: "R roulé, comme en espagnol ou italien",
    audio: "/audio/letters/ra.mp3",
    examples: [
      {
        word: "رَجُل",
        transliteration: "rajul",
        meaning: "homme",
        audio: "/audio/words/rajul.mp3"
      },
      {
        word: "رَأْس",
        transliteration: "ra's",
        meaning: "tête",
        audio: "/audio/words/ras.mp3"
      }
    ],
    notes: "Ne se lie pas à la lettre suivante. R toujours roulé.",
    color: "#c0392b"
  },

  // 11. ZAY
  {
    id: 11,
    letter: "ز",
    name: "Zay",
    nameAr: "زَاي",
    forms: {
      isolated: "ز",
      initial: "ز",
      medial: "ـز",
      final: "ـز"
    },
    transliteration: "z",
    pronunciation: "Comme le 'z' français",
    audio: "/audio/letters/zay.mp3",
    examples: [
      {
        word: "زَيْتُون",
        transliteration: "zaytun",
        meaning: "olive",
        audio: "/audio/words/zaytun.mp3"
      },
      {
        word: "زَهْرَة",
        transliteration: "zahra",
        meaning: "fleur",
        audio: "/audio/words/zahra.mp3"
      }
    ],
    notes: "Un point au-dessus. Ne se lie pas à la lettre suivante.",
    color: "#27ae60"
  },

  // 12. SIN
  {
    id: 12,
    letter: "س",
    name: "Sin",
    nameAr: "سِين",
    forms: {
      isolated: "س",
      initial: "سـ",
      medial: "ـسـ",
      final: "ـس"
    },
    transliteration: "s",
    pronunciation: "Comme le 's' français",
    audio: "/audio/letters/sin.mp3",
    examples: [
      {
        word: "سَمَك",
        transliteration: "samak",
        meaning: "poisson",
        audio: "/audio/words/samak.mp3"
      },
      {
        word: "سَمَاء",
        transliteration: "sama'",
        meaning: "ciel",
        audio: "/audio/words/sama.mp3"
      }
    ],
    notes: "Trois 'dents' sans points. Lettre solaire.",
    color: "#2980b9"
  },

  // 13. SHIN
  {
    id: 13,
    letter: "ش",
    name: "Shin",
    nameAr: "شِين",
    forms: {
      isolated: "ش",
      initial: "شـ",
      medial: "ـشـ",
      final: "ـش"
    },
    transliteration: "sh / ch",
    pronunciation: "Comme le 'ch' français",
    audio: "/audio/letters/shin.mp3",
    examples: [
      {
        word: "شَمْس",
        transliteration: "shams",
        meaning: "soleil",
        audio: "/audio/words/shams.mp3"
      },
      {
        word: "شَجَرَة",
        transliteration: "shajara",
        meaning: "arbre",
        audio: "/audio/words/shajara.mp3"
      }
    ],
    notes: "Trois points au-dessus. Même base que Sin.",
    color: "#f1c40f"
  },

  // 14. SAD
  {
    id: 14,
    letter: "ص",
    name: "Sad",
    nameAr: "صَاد",
    forms: {
      isolated: "ص",
      initial: "صـ",
      medial: "ـصـ",
      final: "ـص"
    },
    transliteration: "ṣ",
    pronunciation: "S emphatique (langue vers le palais)",
    audio: "/audio/letters/sad.mp3",
    examples: [
      {
        word: "صَبَاح",
        transliteration: "sabah",
        meaning: "matin",
        audio: "/audio/words/sabah.mp3"
      },
      {
        word: "صَدِيق",
        transliteration: "sadiq",
        meaning: "ami",
        audio: "/audio/words/sadiq.mp3"
      }
    ],
    notes: "Lettre emphatique. Le son est plus 'lourd' que س.",
    color: "#d35400"
  },

  // 15. DAD
  {
    id: 15,
    letter: "ض",
    name: "Dad",
    nameAr: "ضَاد",
    forms: {
      isolated: "ض",
      initial: "ضـ",
      medial: "ـضـ",
      final: "ـض"
    },
    transliteration: "ḍ",
    pronunciation: "D emphatique, son unique à l'arabe",
    audio: "/audio/letters/dad.mp3",
    examples: [
      {
        word: "ضَوْء",
        transliteration: "daw'",
        meaning: "lumière",
        audio: "/audio/words/daw.mp3"
      },
      {
        word: "ضَيْف",
        transliteration: "dayf",
        meaning: "invité",
        audio: "/audio/words/dayf.mp3"
      }
    ],
    notes: "L'arabe est appelé 'langue du Dad' (لغة الضاد) car ce son n'existe qu'en arabe.",
    color: "#7f8c8d"
  },

  // 16. TA (emphatique)
  {
    id: 16,
    letter: "ط",
    name: "Ta",
    nameAr: "طَاء",
    forms: {
      isolated: "ط",
      initial: "طـ",
      medial: "ـطـ",
      final: "ـط"
    },
    transliteration: "ṭ",
    pronunciation: "T emphatique (langue vers le palais)",
    audio: "/audio/letters/ta_emphatic.mp3",
    examples: [
      {
        word: "طَائِر",
        transliteration: "ta'ir",
        meaning: "oiseau",
        audio: "/audio/words/tair.mp3"
      },
      {
        word: "طَبِيب",
        transliteration: "tabib",
        meaning: "médecin",
        audio: "/audio/words/tabib.mp3"
      }
    ],
    notes: "Version emphatique de ت. Son plus profond.",
    color: "#1abc9c"
  },

  // 17. DHA (emphatique)
  {
    id: 17,
    letter: "ظ",
    name: "Dha",
    nameAr: "ظَاء",
    forms: {
      isolated: "ظ",
      initial: "ظـ",
      medial: "ـظـ",
      final: "ـظ"
    },
    transliteration: "ẓ",
    pronunciation: "DH emphatique, son très rare",
    audio: "/audio/letters/dha_emphatic.mp3",
    examples: [
      {
        word: "ظَهْر",
        transliteration: "dhahr",
        meaning: "dos / midi",
        audio: "/audio/words/dhahr.mp3"
      },
      {
        word: "ظِل",
        transliteration: "dhill",
        meaning: "ombre",
        audio: "/audio/words/dhill.mp3"
      }
    ],
    notes: "Un point au-dessus. Version emphatique de ذ.",
    color: "#9b59b6"
  },

  // 18. AYN
  {
    id: 18,
    letter: "ع",
    name: "Ayn",
    nameAr: "عَيْن",
    forms: {
      isolated: "ع",
      initial: "عـ",
      medial: "ـعـ",
      final: "ـع"
    },
    transliteration: "'",
    pronunciation: "Son guttural profond, contraction de la gorge",
    audio: "/audio/letters/ayn.mp3",
    examples: [
      {
        word: "عَيْن",
        transliteration: "'ayn",
        meaning: "œil / source",
        audio: "/audio/words/ayn.mp3"
      },
      {
        word: "عَرَبِي",
        transliteration: "'arabi",
        meaning: "arabe",
        audio: "/audio/words/arabi.mp3"
      }
    ],
    notes: "Son très caractéristique de l'arabe. Demande de la pratique.",
    color: "#e74c3c"
  },

  // 19. GHAYN
  {
    id: 19,
    letter: "غ",
    name: "Ghayn",
    nameAr: "غَيْن",
    forms: {
      isolated: "غ",
      initial: "غـ",
      medial: "ـغـ",
      final: "ـغ"
    },
    transliteration: "gh",
    pronunciation: "Comme le 'r' grasseyé parisien",
    audio: "/audio/letters/ghayn.mp3",
    examples: [
      {
        word: "غُرَاب",
        transliteration: "ghurab",
        meaning: "corbeau",
        audio: "/audio/words/ghurab.mp3"
      },
      {
        word: "غَابَة",
        transliteration: "ghaba",
        meaning: "forêt",
        audio: "/audio/words/ghaba.mp3"
      }
    ],
    notes: "Un point au-dessus. Similaire au ع mais avec vibration.",
    color: "#3498db"
  },

  // 20. FA
  {
    id: 20,
    letter: "ف",
    name: "Fa",
    nameAr: "فَاء",
    forms: {
      isolated: "ف",
      initial: "فـ",
      medial: "ـفـ",
      final: "ـف"
    },
    transliteration: "f",
    pronunciation: "Comme le 'f' français",
    audio: "/audio/letters/fa.mp3",
    examples: [
      {
        word: "فِيل",
        transliteration: "fil",
        meaning: "éléphant",
        audio: "/audio/words/fil.mp3"
      },
      {
        word: "فَرَاشَة",
        transliteration: "farasha",
        meaning: "papillon",
        audio: "/audio/words/farasha.mp3"
      }
    ],
    notes: "Un point au-dessus. Ressemble à ق mais avec un seul point.",
    color: "#e67e22"
  },

  // 21. QAF
  {
    id: 21,
    letter: "ق",
    name: "Qaf",
    nameAr: "قَاف",
    forms: {
      isolated: "ق",
      initial: "قـ",
      medial: "ـقـ",
      final: "ـق"
    },
    transliteration: "q",
    pronunciation: "K guttural, du fond de la gorge",
    audio: "/audio/letters/qaf.mp3",
    examples: [
      {
        word: "قَمَر",
        transliteration: "qamar",
        meaning: "lune",
        audio: "/audio/words/qamar.mp3"
      },
      {
        word: "قَلْب",
        transliteration: "qalb",
        meaning: "cœur",
        audio: "/audio/words/qalb.mp3"
      }
    ],
    notes: "Deux points au-dessus. Son uvulaire distinctif.",
    color: "#2ecc71"
  },

  // 22. KAF
  {
    id: 22,
    letter: "ك",
    name: "Kaf",
    nameAr: "كَاف",
    forms: {
      isolated: "ك",
      initial: "كـ",
      medial: "ـكـ",
      final: "ـك"
    },
    transliteration: "k",
    pronunciation: "Comme le 'k' français",
    audio: "/audio/letters/kaf.mp3",
    examples: [
      {
        word: "كِتَاب",
        transliteration: "kitab",
        meaning: "livre",
        audio: "/audio/words/kitab.mp3"
      },
      {
        word: "كَلْب",
        transliteration: "kalb",
        meaning: "chien",
        audio: "/audio/words/kalb.mp3"
      }
    ],
    notes: "Petit trait à l'intérieur (comme un mini Alif).",
    color: "#f39c12"
  },

  // 23. LAM
  {
    id: 23,
    letter: "ل",
    name: "Lam",
    nameAr: "لَام",
    forms: {
      isolated: "ل",
      initial: "لـ",
      medial: "ـلـ",
      final: "ـل"
    },
    transliteration: "l",
    pronunciation: "Comme le 'l' français",
    audio: "/audio/letters/lam.mp3",
    examples: [
      {
        word: "لَيْمُون",
        transliteration: "laymun",
        meaning: "citron",
        audio: "/audio/words/laymun.mp3"
      },
      {
        word: "لَيْل",
        transliteration: "layl",
        meaning: "nuit",
        audio: "/audio/words/layl.mp3"
      }
    ],
    notes: "Forme une ligature spéciale avec Alif : لا",
    color: "#8e44ad"
  },

  // 24. MIM
  {
    id: 24,
    letter: "م",
    name: "Mim",
    nameAr: "مِيم",
    forms: {
      isolated: "م",
      initial: "مـ",
      medial: "ـمـ",
      final: "ـم"
    },
    transliteration: "m",
    pronunciation: "Comme le 'm' français",
    audio: "/audio/letters/mim.mp3",
    examples: [
      {
        word: "مَاء",
        transliteration: "ma'",
        meaning: "eau",
        audio: "/audio/words/ma.mp3"
      },
      {
        word: "مَدْرَسَة",
        transliteration: "madrasa",
        meaning: "école",
        audio: "/audio/words/madrasa.mp3"
      }
    ],
    notes: "Forme ronde caractéristique avec une queue.",
    color: "#16a085"
  },

  // 25. NUN
  {
    id: 25,
    letter: "ن",
    name: "Nun",
    nameAr: "نُون",
    forms: {
      isolated: "ن",
      initial: "نـ",
      medial: "ـنـ",
      final: "ـن"
    },
    transliteration: "n",
    pronunciation: "Comme le 'n' français",
    audio: "/audio/letters/nun.mp3",
    examples: [
      {
        word: "نَجْم",
        transliteration: "najm",
        meaning: "étoile",
        audio: "/audio/words/najm.mp3"
      },
      {
        word: "نَار",
        transliteration: "nar",
        meaning: "feu",
        audio: "/audio/words/nar.mp3"
      }
    ],
    notes: "Un point au-dessus. Ressemble à ب mais la coupe est plus ouverte.",
    color: "#c0392b"
  },

  // 26. HA
  {
    id: 26,
    letter: "ه",
    name: "Ha",
    nameAr: "هَاء",
    forms: {
      isolated: "ه",
      initial: "هـ",
      medial: "ـهـ",
      final: "ـه"
    },
    transliteration: "h",
    pronunciation: "H léger, comme expirer de l'air",
    audio: "/audio/letters/ha_light.mp3",
    examples: [
      {
        word: "هِلَال",
        transliteration: "hilal",
        meaning: "croissant (lune)",
        audio: "/audio/words/hilal.mp3"
      },
      {
        word: "هَدِيَّة",
        transliteration: "hadiyya",
        meaning: "cadeau",
        audio: "/audio/words/hadiyya.mp3"
      }
    ],
    notes: "Ne pas confondre avec ح (Ha guttural). Celui-ci est plus léger.",
    color: "#27ae60"
  },

  // 27. WAW
  {
    id: 27,
    letter: "و",
    name: "Waw",
    nameAr: "وَاو",
    forms: {
      isolated: "و",
      initial: "و",
      medial: "ـو",
      final: "ـو"
    },
    transliteration: "w / u / ū",
    pronunciation: "Comme 'w' anglais ou 'ou' français long",
    audio: "/audio/letters/waw.mp3",
    examples: [
      {
        word: "وَرْد",
        transliteration: "ward",
        meaning: "rose (fleur)",
        audio: "/audio/words/ward.mp3"
      },
      {
        word: "وَلَد",
        transliteration: "walad",
        meaning: "garçon",
        audio: "/audio/words/walad.mp3"
      }
    ],
    notes: "Ne se lie pas à la lettre suivante. Peut être consonne ou voyelle longue.",
    color: "#2980b9"
  },

  // 28. YA
  {
    id: 28,
    letter: "ي",
    name: "Ya",
    nameAr: "يَاء",
    forms: {
      isolated: "ي",
      initial: "يـ",
      medial: "ـيـ",
      final: "ـي"
    },
    transliteration: "y / i / ī",
    pronunciation: "Comme 'y' français ou 'i' long",
    audio: "/audio/letters/ya.mp3",
    examples: [
      {
        word: "يَد",
        transliteration: "yad",
        meaning: "main",
        audio: "/audio/words/yad.mp3"
      },
      {
        word: "يَوْم",
        transliteration: "yawm",
        meaning: "jour",
        audio: "/audio/words/yawm.mp3"
      }
    ],
    notes: "Deux points en dessous. Peut être consonne ou voyelle longue.",
    color: "#f1c40f"
  }
];

// Groupes de lettres pour l'apprentissage
export const letterGroups = {
  // Lettres sans points
  pointless: [1, 6, 8, 10, 12, 14, 16, 18, 23, 24, 26, 27], // ا ح د ر س ص ط ع ل م ه و
  
  // Un point en dessous
  onePointBelow: [2, 5, 28], // ب ج ي
  
  // Un point au-dessus
  onePointAbove: [7, 9, 11, 17, 19, 20, 25], // خ ذ ز ظ غ ف ن
  
  // Deux points au-dessus
  twoPointsAbove: [3, 21], // ت ق
  
  // Trois points au-dessus
  threePointsAbove: [4, 13], // ث ش
  
  // Lettres qui ne se lient pas à gauche
  nonConnecting: [1, 8, 9, 10, 11, 27], // ا د ذ ر ز و
  
  // Lettres emphatiques
  emphatic: [14, 15, 16, 17], // ص ض ط ظ
  
  // Lettres gutturales
  guttural: [6, 7, 18, 19, 21], // ح خ ع غ ق
  
  // Lettres similaires (à ne pas confondre)
  similarShapes: {
    group1: [2, 3, 4, 25], // ب ت ث ن
    group2: [5, 6, 7], // ج ح خ
    group3: [8, 9], // د ذ
    group4: [10, 11], // ر ز
    group5: [12, 13], // س ش
    group6: [14, 15], // ص ض
    group7: [16, 17], // ط ظ
    group8: [18, 19], // ع غ
    group9: [20, 21], // ف ق
  }
};

export default arabicLetters;
